import React from 'react';
import { IDisabled } from './types/type';

export const FilterIcon = ({ disabled }: IDisabled) => {
  return (
    <div className="vbz-icon-corporates-club">
      <div
        data-testid="filter-icon"
        className={disabled ? 'vbz-icon-corporates-club-filter-disabled' : 'vbz-icon-corporates-club-filter'}
      />
    </div>
  );
};
